import { useEffect, useState } from 'react';

export function useDpr() {
  const [dpr, setDpr] = useState(typeof window !== 'undefined' ? window.devicePixelRatio : 1)

  useEffect(() => {
    const handler = () => {
      setDpr(window.devicePixelRatio)
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handler);
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', handler);
      }
    }
  }, []);

  return dpr;
}